import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuthSession, useTranslation } from '@dukanti/shared';
import type { TranslationKey } from '@dukanti/shared';
import { supabase } from '@/lib/supabase';
import { useCurrentStore } from '@/hooks/use-current-store';
import { Button } from '@/components/ui/button';
import { AdminPreparedOrderForm } from '@/features/orders';

export function OrderPrepareRoute(): React.JSX.Element {
  const { t, dir } = useTranslation();
  const authSession = useAuthSession(supabase);
  const { storeId } = useCurrentStore(authSession);

  return (
    <main
      dir={dir}
      data-testid="order-prepare-route"
      className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8"
    >
      <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="text-start">
          <h1 className="font-display text-foreground text-[28px] font-bold leading-tight tracking-tight">
            {t('admin.orders.prepare.title' as TranslationKey)}
          </h1>
          <p className="text-muted-foreground mt-2 text-sm">
            {t('admin.orders.prepare.subtitle' as TranslationKey)}
          </p>
        </div>
        <Button asChild variant="outline">
          <Link to="/orders">
            <ArrowRight className="me-2 h-4 w-4 rtl:rotate-180" />
            {t('admin.orders.prepare.backToOrders' as TranslationKey)}
          </Link>
        </Button>
      </div>

      {storeId ? (
        <AdminPreparedOrderForm storeId={storeId} />
      ) : (
        <div className="border-border bg-card shadow-admin-card rounded-lg border p-6 text-start">
          <p className="text-muted-foreground">
            {t('admin.orders.detail.loading' as TranslationKey)}
          </p>
        </div>
      )}
    </main>
  );
}
